import { emptyCvTexts, ICareerProfileFormValues } from 'organisms/CareerProfileForm/types';

/**
 * Empty profile form values (spec 0018, increment B). Used only for the brief
 * window before `myCareerProfile` (created on first read) comes back.
 */
export const emptyCareerProfileValues: ICareerProfileFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  city: '',
  country: '',
  relocationReady: false,
  workMode: '',
  workPermit: '',
  availableFrom: '',
  seniority: '',
  desiredPosition: '',
  desiredSalary: '',
  githubUrl: '',
  linkedinUrl: '',
  portfolioUrl: '',
  skills: [],
  customSkills: [],
  projects: [],
  experience: [],
  education: [],
  languages: [],
  certificates: [],
  cvTexts: emptyCvTexts(),
};
